"use client";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import * as React from "react";
import { cj } from "../utils";
import { SliderContext } from "./shared/sliderContext";
function useAutoplay() {
    const { autoplay, delay, autoMax, isAutoplayPaused, setAutoplayPause, goToNextSlide } = React.useContext(SliderContext);
    const [autoMaxCount, setAutoMaxCount] = React.useState(0);
    const autoMaxReached = React.useMemo(()=>autoMaxCount >= autoMax && autoMax > 0, [
        autoMax,
        autoMaxCount
    ]);
    React.useEffect(()=>{
        const shouldAutoplay = autoplay && !autoMaxReached && !isAutoplayPaused;
        if (shouldAutoplay) {
            const interval = setInterval(()=>{
                setAutoMaxCount((prev)=>prev + 1);
                goToNextSlide();
            }, delay);
            return ()=>clearInterval(interval);
        }
    }, [
        autoplay,
        delay,
        goToNextSlide,
        autoMaxReached,
        isAutoplayPaused
    ]);
    const resumeAutoplay = ()=>setAutoplayPause(true);
    const pauseAutoplay = ()=>setAutoplayPause(false);
    return {
        resumeAutoplay,
        pauseAutoplay
    };
}
const SliderMask = /*#__PURE__*/ React.forwardRef(function SliderMask(_param, ref) {
    var { className = "", children } = _param, props = _object_without_properties(_param, [
        "className",
        "children"
    ]);
    const { setSlideAmount } = React.useContext(SliderContext);
    const [isHovered, setHovered] = React.useState(false);
    const [slides, setSlides] = React.useState([]);
    const { resumeAutoplay, pauseAutoplay } = useAutoplay();
    React.useEffect(()=>{
        const extractNonFragmentChildren = (_children)=>{
            var _childrenList_;
            const childrenList = React.Children.toArray(_children).filter((child)=>/*#__PURE__*/ React.isValidElement(child));
            if (childrenList.length === 1 && ((_childrenList_ = childrenList[0]) === null || _childrenList_ === void 0 ? void 0 : _childrenList_.type) === React.Fragment) {
                const fragmentProps = childrenList[0].props;
                return extractNonFragmentChildren(fragmentProps.children);
            } else {
                return childrenList;
            }
        };
        const _slides = extractNonFragmentChildren(children);
        setSlideAmount(_slides.length);
        setSlides(_slides);
    }, [
        children
    ]);
    return /*#__PURE__*/ React.createElement("div", _object_spread_props(_object_spread({}, props), {
        className: cj(className, "w-slider-mask"),
        onMouseEnter: ()=>{
            pauseAutoplay();
            setHovered(true);
        },
        onMouseLeave: ()=>{
            resumeAutoplay();
            setHovered(false);
        },
        onFocus: ()=>pauseAutoplay(),
        onBlur: ()=>resumeAutoplay(),
        ref: ref
    }), slides.map((child, index)=>{
        return /*#__PURE__*/ React.cloneElement(child, _object_spread_props(_object_spread({}, child.props), {
            index
        }));
    }), /*#__PURE__*/ React.createElement("div", {
        "aria-live": isHovered ? "polite" : "off",
        "aria-atomic": "true",
        className: "w-slider-aria-label"
    }));
});
export default SliderMask;
